import { storeModules, userRoles } from '@/helpers'

export const sideBarStore = {
  namespaced: true,
  state: {
    swagStoreMenu: [
      {
        menuId: 1,
        title: 'Swag store',
        route: '/report',
        icon: require('../assets/home-icon.svg'),
        allowedFor: [
          userRoles.MEMBER,
          userRoles.TEAM_OWNER,
          userRoles.STORE_ADMIN
        ],
        hiddenSubmenu: true,
        submenus: [
          {
            parentMenuId: 1,
            title: 'Send gift',
            route: '/gifts',
            icon: require('../assets/gift-icon-2.svg'),
            allowedFor: [
              userRoles.MEMBER,
              userRoles.TEAM_OWNER,
              userRoles.STORE_ADMIN
            ],
            child: true
          },
          {
            parentMenuId: 1,
            title: 'Orders',
            route: '/orders',
            icon: require('../assets/orders-icon.svg'),
            allowedFor: [userRoles.TEAM_OWNER],
            child: true
          },
          {
            parentMenuId: 1,
            title: 'Card templates',
            route: '/manage-templates',
            allowedFor: [
              userRoles.MEMBER,
              userRoles.TEAM_OWNER,
              userRoles.STORE_ADMIN
            ],
            child: true
          },
          {
            parentMenuId: 1,
            title: 'Redemption',
            route: '/redemptions',
            icon: require('../assets/orders-icon.svg'),
            allowedFor: [userRoles.TEAM_OWNER, userRoles.STORE_ADMIN],
            child: true
          },
          {
            parentMenuId: 1,
            title: 'Users',
            route: '/members',
            icon: require('../assets/users-icon.svg'),
            allowedFor: [userRoles.TEAM_OWNER],
            child: true
          },
          {
            parentMenuId: 1,
            title: 'Recipients',
            route: '/recipient-list',
            allowedFor: [
              // userRoles.LIMITED_USER,
              userRoles.MEMBER,
              userRoles.TEAM_OWNER,
              userRoles.STORE_ADMIN
            ],
            child: true
          },
          {
            parentMenuId: 7,
            title: 'Settings',
            route: '/settings',
            allowedFor: [
              userRoles.MEMBER,
              userRoles.TEAM_OWNER,
              userRoles.STORE_ADMIN
            ],
            child: true
          }
        ]
      },
      {
        menuId: 0,
        title: 'Projects',
        route: '/projects',
        allowedFor: [
          userRoles.LIMITED_USER,
          userRoles.MEMBER,
          userRoles.TEAM_OWNER,
          userRoles.STORE_ADMIN
        ],
        hiddenSubmenu: true,
        submenus: []
      },

      {
        menuId: 7,
        title: 'E-Commerce',
        route: '/e-commerce/details',
        allowedFor: [userRoles.TEAM_OWNER, userRoles.STORE_ADMIN],
        hiddenSubmenu: true,
        onlyTesting: true,
        submenus: [
          {
            parentMenuId: 7,
            title: 'Orders',
            route: '/e-commerce/orders',
            icon: null,
            allowedFor: [userRoles.TEAM_OWNER],
            child: true
          },

          {
            parentMenuId: 7,
            title: 'Payouts',
            route: '/e-commerce/payouts',
            icon: null,
            allowedFor: [userRoles.TEAM_OWNER],
            child: true
          },
          {
            parentMenuId: 7,
            title: 'Products',
            route: '/e-commerce/products',
            icon: null,
            allowedFor: [userRoles.TEAM_OWNER],
            child: true
          },
          {
            parentMenuId: 7,
            title: 'Gift Cards',
            route: '/e-commerce/gift-cards',
            icon: null,
            allowedFor: [userRoles.TEAM_OWNER, userRoles.STORE_ADMIN],
            child: true
          },
          {
            parentMenuId: 7,
            title: 'Settings',
            route: '/e-commerce/setting',
            icon: null,
            allowedFor: [userRoles.TEAM_OWNER],
            child: true
          }
        ]
      },
      {
        menuId: 2,
        title: 'Inventory',
        route: '/manage-inventory',
        allowedFor: [userRoles.TEAM_OWNER, userRoles.STORE_ADMIN],
        hiddenSubmenu: true,
        submenus: []
      },
      {
        menuId: 4,
        title: 'Billing',
        route: '/manage-billing',
        allowedFor: [userRoles.TEAM_OWNER],
        hiddenSubmenu: true,
        submenus: []
      },

      {
        menuId: 5,
        title: 'Settings',
        route: '/profile',
        icon: require('../assets/integration-icon.svg'),
        allowedFor: [
          userRoles.MEMBER,
          userRoles.TEAM_OWNER,
          userRoles.STORE_ADMIN
        ],
        hiddenSubmenu: true,
        submenus: [
          {
            parentMenuId: 5,
            title: 'Integrations',
            route: '/integrations',
            allowedFor: [
              userRoles.MEMBER,
              userRoles.TEAM_OWNER,
              userRoles.STORE_ADMIN
            ],
            child: true
          }
        ]
      }
    ],
    projectStoreMenu: [
      {
        menuId: 0,
        title: 'Projects',
        route: '/projects',
        allowedFor: [
          userRoles.LIMITED_USER,
          userRoles.MEMBER,
          userRoles.TEAM_OWNER,
          userRoles.STORE_ADMIN
        ],
        hiddenSubmenu: true,
        submenus: []
      },

      {
        menuId: 4,
        title: 'Billing',
        route: '/manage-billing',
        allowedFor: [userRoles.TEAM_OWNER],
        hiddenSubmenu: true,
        submenus: []
      },

      {
        menuId: 5,
        title: 'Settings',
        route: '/profile',
        icon: require('../assets/integration-icon.svg'),
        allowedFor: [
          userRoles.MEMBER,
          userRoles.TEAM_OWNER,
          userRoles.STORE_ADMIN
        ],
        hiddenSubmenu: true,
        submenus: []
      }
    ]
  },
  getters: {
    getSideBarMenu(state, getters, rootState) {
      let { teamModuleNames } = rootState.team.team
      let { roles = [] } = rootState.profile.user

      if (teamModuleNames.length <= 0) {
        return []
      }

      let menuOptionsToDisplay = []

      teamModuleNames.forEach(module => {
        switch (module) {
          case storeModules.swag_store:
            for (let index = 0; index < state.swagStoreMenu.length; index++) {
              const menu = state.swagStoreMenu[index]
              let show = false

              let showInProduction = true

              if (
                menu.onlyTesting &&
                process.env.VUE_APP_NODE_ENV === 'production'
              ) {
                showInProduction = false
              }
              // filter only those menu options that the current user can see
              roles.map(role => {
                if (menu.allowedFor.includes(role)) {
                  show = true
                }
              })

              let foundIndex = menuOptionsToDisplay.findIndex(
                m => m.menuId === menu.menuId
              )
              if (foundIndex === -1 && show && showInProduction) {
                menu.submenus = menu.submenus.filter(submenu => {
                  let showSubmenu = false
                  roles.forEach(role => {
                    if (submenu.allowedFor.includes(role)) {
                      showSubmenu = true
                    }
                  })
                  return showSubmenu
                })

                menuOptionsToDisplay.push(menu)
              }
            }

            break
          case storeModules.project:
            for (
              let menuIndex = 0;
              menuIndex < state.projectStoreMenu.length;
              menuIndex++
            ) {
              const menu = state.projectStoreMenu[menuIndex]
              let show = false
              // filter only those menu options that the current user can see
              roles.map(role => {
                if (menu.allowedFor.includes(role)) {
                  show = true
                }
              })

              let foundIndex = menuOptionsToDisplay.findIndex(
                m => m.menuId === menu.menuId
              )
              if (foundIndex === -1 && show) menuOptionsToDisplay.push(menu)
            }
            break
        }
      })

      return menuOptionsToDisplay
    }
  }
}
